import { createAction, props } from "@ngrx/store";
import { IEntrada, IEntradas, INuevaEntrada } from "../../interfaces/entradas";
import { IDetalleTema } from "../../interfaces/temas";
import { AcuerdoRequest, ICNuevoTema } from "../../interfaces/acuerdo";
import { IAcuerdo, IArchivoAcuerdo } from "../../interfaces/acuerdos";

//editar tema
export const validarFormularios = createAction(
  "[Formularios] Validar Formularios"
);
export const guardarFormularios = createAction(
  "[Formularios] Guardar Formularios"
);
export const guardarFormulariosAcuerdo = createAction(
  "[Formularios] Guardar Formularios Acuerdo",
  props<{
    acuerdo: IAcuerdo;
    temas: IDetalleTema[];
    archivos?: IArchivoAcuerdo[];
  }>()
);
export const cancelarFormulariosAcuerdo = createAction(
  "[Formularios] Cancelar Formularios Acuerdo",
  props<{ temas: IDetalleTema[] }>()
);
export const guardarFormulariosSuccess = createAction(
  "[Formularios] Guardar Formularios Success",
  props<{ response: any }>()
);
export const guardarFormulariosFailure = createAction(
  "[Formularios] Guardar Formularios Failure",
  props<{ error: any }>()
);
//nuevo tema
export const guardarNuevoTema = createAction(
  "[Formularios] guardar Formularios Nuevo Tema",
  props<{
    temas: ICNuevoTema[];
    acuerdoActual: IAcuerdo;
    request: AcuerdoRequest;
  }>()
);

export const guardarNuevoTemaSuccess = createAction(
  "[Formularios] Guardar Formularios Nuevo Success",
  props<{ response: any }>()
);

export const cargarDatosGuardados = createAction(
  "[Formularios] cargar Datos Guardados",
  props<{ temas: any[] }>()
);
export const guardarNuevoTemaFailure = createAction(
  "[Formularios] Guardar Nuevo Tema Failure",
  props<{ error: any }>()
);

export const resetForms = createAction("[Formulario] reset Forms");
